import axios from "axios";

//const
const EQUIPMENT_DETAIL_STORE_EQUIPMENT_DATA = "equipmentDetail/EQUIPMENT_DETAIL_STORE_EQUIPMENT_DATA";
const EQUIPMENT_DETAIL_STORE_CONFIG_DATA = "equipmentDetail/EQUIPMENT_DETAIL_STORE_CONFIG_DATA";
const EQUIPMENT_DETAIL_INITIAL_DATA = "equipmentDetail/EQUIPMENT_DETAIL_INITIAL_DATA";
const EQUIPMENT_DETAIL_TOGGLE_LOADING = "equipmentDetail/EQUIPMENT_DETAIL_TOGGLE_LOADING";

//reducer
export const equipmentDetail = (state = {
  loading: false,

  id: "",
  equipmentData: {
    id: "",
    equipmentType: {name: ""},
    equipmentId: "",
    equipmentIp: "",
    equipmentPort: "",
    equipmentCertify: {id: ""},
    equipmentStatus: {name: ""},
  },
  equipmentConfig: {
    transferProtocol: {name: ""},
    compressMethod: {name: ""},
    dataTransferUrl: "",
    fileTransferUrl: "",
    period: "",
    buffer: "",
    collectNodeConfigs: [],
  },
}, action) => {
  switch (action.type) {
    case EQUIPMENT_DETAIL_STORE_EQUIPMENT_DATA:
      return {
        ...state,
        id: action.data.id,
        equipmentData: action.data,
        equipmentConfig: action.data.equipmentConfig
      };
    case EQUIPMENT_DETAIL_TOGGLE_LOADING:
      return {
        ...state,
        loading: action.data
      };
    default:
      return state
  }
};

/**
 * check and init equipment Detail
 */
export const initEquipmentDetail = (data) => (dispatch) => {
  let id = data.id;
  if (id !== null && id !== undefined && id !== "") {
    dispatch(toggleLoading(true));
    axios.get(`/api-equipment/getEquipmentById/${id}`, {contentType: "application/json"}).then(
      response => {
        dispatch(toggleLoading(false));
        if (response.data) {
          dispatch(storeEquipmentDetail(response.data));
        } else {
          this.props.history.push("/exception/415");
        }
      }
    );
  } else {
    dispatch(toggleLoading(false));
    this.props.history.push("/exception/415");
  }
};

/**
 * store equipment Detail
 */
export const storeEquipmentDetail = (equipments) => {
  return {
    type: EQUIPMENT_DETAIL_STORE_EQUIPMENT_DATA,
    data: equipments
  }
};

/**
 * toggle loading
 */
export const toggleLoading = (show) => {
  return {
    type: EQUIPMENT_DETAIL_TOGGLE_LOADING,
    data: show
  }
};
